import { useContext } from 'react';
import { Box, Typography } from '@mui/material';
import { UserContext } from '../Context/UserContext';

export default function PermissionGate({ section, requireSuperAdmin = false, children }) {
    const { userInfo } = useContext(UserContext);

    if (userInfo === null) return null; // account_info encore en chargement

    const isSuperAdmin = userInfo.is_super_admin === true;
    const allowed = requireSuperAdmin ? isSuperAdmin : (isSuperAdmin || (userInfo.permissions || []).includes(section));

    if (!allowed) {
        return (
            <Box sx={{ p: 4, textAlign: 'center' }}>
                <Typography variant="h6">Accès refusé</Typography>
                <Typography color="text.secondary">Vous n'avez pas la permission d'accéder à cette section.</Typography>
            </Box>
        );
    }
    return children;
}
